(function() {
  var container = document.querySelector('.article-toc');
  var content = document.querySelector('.article-template__content');
  if (!container || !content) return;

  var headings = Array.prototype.filter.call(
    content.querySelectorAll('h2, h3'),
    function(h) { return !h.closest('.sv-article-product'); }
  );
  var h2Count = headings.filter(function(h) { return h.tagName === 'H2'; }).length;
  if (h2Count < 3) return;

  var list = container.querySelector('.article-toc__list');
  if (!list) return;

  var h2Index = 0;
  var h3Index = 0;

  headings.forEach(function(heading) {
    if (!heading.id) {
      heading.id = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'section';
    }
    var baseId = heading.id;
    var counter = 2;
    while (document.querySelectorAll('[id="' + heading.id + '"]').length > 1) {
      heading.id = baseId + '-' + counter++;
    }

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.className = 'article-toc__link';

    if (heading.tagName === 'H2') {
      h2Index++;
      h3Index = 0;
      li.className = 'article-toc__item';
      a.innerHTML = '<span class="article-toc__number">' + h2Index + '.</span> ' + heading.textContent;
    } else {
      h3Index++;
      li.className = 'article-toc__item article-toc__item--sub';
      a.innerHTML = '<span class="article-toc__number">' + h2Index + '.' + h3Index + '.</span> ' + heading.textContent;
    }

    a.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById(heading.id);
      if (target) {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + heading.id);
      }
    });

    li.appendChild(a);
    list.appendChild(li);
  });

  container.style.display = '';

  var details = container.querySelector('details');
  if (details && window.innerWidth >= 750) {
    details.setAttribute('open', '');
  }

  var links = list.querySelectorAll('.article-toc__link');
  var allHeadings = Array.prototype.slice.call(headings);
  var currentIndex = -1;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = allHeadings.indexOf(entry.target);
        if (idx !== -1 && idx !== currentIndex) {
          currentIndex = idx;
          links.forEach(function(link, i) {
            if (i === idx) {
              link.setAttribute('aria-current', 'true');
              link.parentElement.classList.add('active');
            } else {
              link.removeAttribute('aria-current');
              link.parentElement.classList.remove('active');
            }
          });
        }
      }
    });
  }, {
    root: null,
    rootMargin: '-80px 0px -66% 0px',
    threshold: 0
  });

  allHeadings.forEach(function(h) { observer.observe(h); });
})();
